import Modal from "react-modal";
import { AlertIconBackground, Btns, CancelIcon, Container, Content, ItemContainer, Upper } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { getDay, getKorDate } from "utils/date";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    width: "454px",
    borderRadius: "20px",
    transform: "translate(-50%, -50%)",
    padding: 0,
    margin: 0,
    overflow: "visible",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};

export default function RepeatRuleSettingModal(props: ReservationConflictModalProps) {
  const {
    modalIsOpen,
    closeModal,
    enableReservationCount,
    enableReservationTimes,
    disableReservationCount,
    onReservation,
  } = props;

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container>
        <CancelIcon>
          <UI.IconButton.Normal
            type="primary"
            icon="x"
            size={20}
            color="var(--alias-color-label-normal)"
            onClick={closeModal}
          />
        </CancelIcon>
        <Upper>
          <AlertIconBackground>
            <UI.Icon name="inform" size={56} color="var(--alias-color-status-cautionary)" />
          </AlertIconBackground>
          <Content>
            <UI.Typography
              type="heading01"
              fontStyle="bold"
              color="var(--alias-color-label-normal)"
              style={{
                textAlign: "center",
              }}
            >
              일부 예약에 중복 건이 존재합니다.
              <br />
              중복을 제외한 예약을 계속하시겠습니까?
            </UI.Typography>
            <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-label-normal)">
              예약 가능:{" "}
              <span style={{ fontWeight: 700, color: "var(--alias-color-status-positive)" }}>
                {enableReservationCount}
              </span>
              <span style={{ fontWeight: 700 }}>건</span> | 예약 불가(중복 예약):{" "}
              <span
                style={{
                  fontWeight: 700,
                  color: "var(--alias-color-status-negative)",
                }}
              >
                {disableReservationCount}
              </span>
              <span style={{ fontWeight: 700 }}>건</span>
            </UI.Typography>
            <ItemContainer>
              <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
                중복 발생 건
              </UI.Typography>
              <UI.Typography type="label01" fontStyle="regular" color="var(--alias-color-label-normal)">
                {enableReservationTimes.map((item) => (
                  <p>
                    • {getKorDate(item.toDateString())} ({`${getDay(item.toDateString())})`}
                  </p>
                ))}
              </UI.Typography>
            </ItemContainer>
          </Content>
        </Upper>
        <Btns>
          <UI.Button
            title="예약 내역 재설정하기"
            onClick={closeModal}
            size="large"
            type="outlined"
            style={{ whiteSpace: "nowrap" }}
          />
          <UI.Button title="중복 제외 예약하기" onClick={onReservation} size="large" style={{ whiteSpace: "nowrap" }} />
        </Btns>
      </Container>
    </Modal>
  );
}
